import { required } from "react-admin";

// TODO Add regex validator for domain
export const validateDomain = required();
